module.exports = __webpack_public_path__ + "img/主机.96d51b7f.png";